/**
 * @generated SignedSource<<330dad360c2dbf5b5e7f4add0fb204a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTile_nftAuctionBidderRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemInternalContext_nftAuctionBidderRef">;
  readonly " $fragmentType": "NftItemTile_nftAuctionBidderRef";
};
export type NftItemTile_nftAuctionBidderRef$key = {
  readonly " $data"?: NftItemTile_nftAuctionBidderRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuctionBidderRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTile_nftAuctionBidderRef",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemInternalContext_nftAuctionBidderRef"
    }
  ],
  "type": "NftAuctionBidderRef",
  "abstractKey": null
};

(node as any).hash = "de9fd2a74384ae524e4af66894cdfb17";

export default node;
